import { render } from "./IconTrekBattery.vue?vue&type=template&id=7a78f58b"
import script from "./IconTrekBattery.vue?vue&type=script&lang=js"
export * from "./IconTrekBattery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__